<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body p-0">
    <div *ngIf="insertionMessage != null" class="progress-message">
        <span *ngIf="isInserting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> {{
        insertionMessage }}
    </div>
    <div *ngIf="formatError" class="alert alert-danger">
        <p>
            The format of the imported data is incorrect. Please download the template and ensure the data matches the
            required format.
        </p>
        <button class="download-button" matTooltip="Click here to download CSV format"
            (click)="downloadTemplate()">Download Template</button>
    </div>
    <div class="table-responsive" *ngIf="displayTable">
        <table *ngIf="!formatError" mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
            <!-- Checkbox Column -->
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                    <input type="checkbox" (change)="toggleSelectAll($event.target.checked)"
                        [checked]="selectedScales.length === importedData.length && importedData.length > 0">
                </th>
                <td mat-cell *matCellDef="let scale">
                    <input type="checkbox" (change)="onCheckboxChange(scale, $event.target.checked)"
                        [checked]="isSelected(scale)">
                </td>
            </ng-container>

            <ng-container matColumnDef="conceptType">
                <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Concept Type</th>
                <td mat-cell *matCellDef="let employee">{{ employee.conceptType }}</td>
            </ng-container>

            <ng-container matColumnDef="computeSSS">
                <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Compute SSS</th>
                <td mat-cell *matCellDef="let employee">{{ employee.computeSSS }}</td>
            </ng-container>

            <ng-container matColumnDef="computePhilhealth">
                <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Compute Philhealth</th>
                <td mat-cell *matCellDef="let employee">{{ employee.computePhilhealth }}</td>
            </ng-container>

            <ng-container matColumnDef="computePagibig">
                <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Compute Pagibig</th>
                <td mat-cell *matCellDef="let employee">{{ employee.computePagibig }}</td>
            </ng-container>

            <ng-container matColumnDef="computeLateFromFixed">
                <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Compute Late From Fixed</th>
                <td mat-cell *matCellDef="let employee">{{ employee.computeLateFromFixed }}</td>
            </ng-container>

            <ng-container matColumnDef="sssMatrix">
                <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>SSS Matrix</th>
                <td mat-cell *matCellDef="let employee">{{ employee.sssMatrix }}</td>
            </ng-container>

            <ng-container matColumnDef="philhealthMatrix">
                <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Philhealth Matrix</th>
                <td mat-cell *matCellDef="let employee">{{ employee.philhealthMatrix }}</td>
            </ng-container>

            <ng-container matColumnDef="pagibigMatrix">
                <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Pagibig Matrix</th>
                <td mat-cell *matCellDef="let employee">{{ employee.pagibigMatrix }}</td>
            </ng-container>

            <!-- Table Header and Data Rows -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <!-- Pagination -->
        <mat-paginator *ngIf="!formatError" [pageSizeOptions]="[5,10]" showFirstLastButtons></mat-paginator>
    </div>
</div>

<div class="modal-footer large-modal" *ngIf="!isImported">
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('cancel')">Cancel</button>
    <button *ngIf="!isLoading; else loadingTemplate" [disabled]="formatError" type="button" class="btn btn-primary"
        (click)="saveSelectedScales()">
        Save
    </button>
    <ng-template #loadingTemplate>
        <button type="button" class="btn btn-primary" disabled>
            Save <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </button>
    </ng-template>
</div>

<div class="modal-footer large-modal" *ngIf="isImported">
    <button type="button" class="btn btn-secondary" (click)="onClose()">Close</button>
</div>